import noop from 'lodash-es/noop'
import * as React from 'react'

import { Output as AddToBagOutput } from '../../../lib/hooks/useBag'

import { Template } from './Template'
import { useViewModel } from './useViewModel'

interface Props {
  resetInvalidBagClickStatus?: AddToBagOutput['resetInvalidBagClickStatus']
  /** Whether or not pricing should be displayed within the embroidery summary. */
  withPricing?: boolean
  /** The discount messaging that should be displayed at the bottom of the embroidery summary */
  discountMessage?: string
}

export const EmbroiderySummary: React.FC<Props> = ({
  resetInvalidBagClickStatus = noop,
  withPricing = true,
  discountMessage,
}) => {
  const viewModel = useViewModel({
    resetInvalidBagClickStatus,
    discountMessage,
  })

  return <Template {...viewModel} withPricing={withPricing} />
}
